(
    function (skyward, $, undefined)
    {
        skyward.academicStandardMaintenance = skyward.academicStandardMaintenance || {};
        var BROWSE_NAME = "AcademicStandardMaintenance";
        var DOV_NAME = "MaintainAcademicStandardsDOV";
        var GRADEBOOK_PATH = "Gradebook/CalculationGroup";
        var CURRICULUM_PATH = "Curriculum/Curriculum";
        var DETAILS_BROWSE_NAME = "detailsPanel_" + BROWSE_NAME;
        var READONLY_BROWSE_NAME = "AcademicStandardMaintenanceReadOnly";
        var DETAILS_READONLY_BROWSE_NAME = "detailsPanel_" + READONLY_BROWSE_NAME;
        var init = function (selector)
        {
            var academicStandardMaintenanceContainer = $(selector).find(".academicStandardMaintenance");
            if (academicStandardMaintenanceContainer.length == 0)
            {
                return;
            }

            var isInDetailsPanel = academicStandardMaintenanceContainer.attr("id").indexOf("detailsPanel_") > -1;

            var updateMaintenanceBrowseAjaxRequest = null;

            var sharedUpdateAcademicStandardMaintenanceBrowse = function (data, url, browseParentSelector, browseSelector, browseName)
            {
                $(".academicStandardAtLevelFilter").each(function ()
                {
                    var academicStandardAtLevelFilter = $(this);
                    data[academicStandardAtLevelFilter.attr("id")] = academicStandardAtLevelFilter.find(".dmsBackingData").val()
                });

                updateMaintenanceBrowseAjaxRequest = $.ajax({
                    url: url,
                    type: "POST",
                    dataType: "viewparthtml",
                    data: data,
                    activityIndicator: { silent: true },
                    success: function (browse)
                    {
                        var browseParentDiv = $(browseParentSelector)
                        var browseID = browseParentDiv.attr('id');

                        if (browseParentDiv.parents("#detailsPanel").length > 0)
                        {
                            browse = $(browse);
                            browse.find(`#${browseName}`).addBack(`#${browseName}`).attr("id", `detailsPanel_${browseName}`);
                        }
                        browseParentDiv.html(browse);
                        skyward.window.notifyDOMLoad('#' + browseID);
                        updateMaintenanceBrowseAjaxRequest = null;
                    }
                });            
                return updateMaintenanceBrowseAjaxRequest;
            };

            var readOnlyBrowseElement = skyward.browse.browseList[READONLY_BROWSE_NAME] !== undefined ? skyward.browse.browseList[READONLY_BROWSE_NAME] : skyward.browse.browseList[DETAILS_READONLY_BROWSE_NAME];

            if (readOnlyBrowseElement)
            {
                var preUpdateReadOnlyMaintenanceBrowse = function ()
                {
                    if (updateMaintenanceBrowseAjaxRequest)
                    {
                        updateMaintenanceBrowseAjaxRequest.abort();
                    }

                    var data = {
                        pageModule: readOnlyBrowseElement.pageModule,
                        pageObject: readOnlyBrowseElement.pageObject,
                        pageScreen: readOnlyBrowseElement.pageScreen,
                        taskName: readOnlyBrowseElement.taskName,
                        academicSetID: $('#AcademicStandardSetFilter').val(),
                        academicSubjectIDs: $('#AcademicStandardSubjectFilterData').val(),
                        academicGradeRangeIDs: $('#AcademicStandardGradeRangeFilterData').val(),
                        renderInDetailsPanel: isInDetailsPanel
                    };
                    
                    var url = skyward.global.virtualDir + readOnlyBrowseElement.pageModule + "/" + readOnlyBrowseElement.pageObject + "/UpdateAcademicStandardMaintenanceReadOnlyBrowse";
                    var browseParentSelector = '#' + (isInDetailsPanel ? DETAILS_READONLY_BROWSE_NAME : READONLY_BROWSE_NAME);
                    var browseSelector = '.browse';

                    sharedUpdateAcademicStandardMaintenanceBrowse(data, url, browseParentSelector, browseSelector, READONLY_BROWSE_NAME);
                };

                $(selector).find('.academicStandardMaintenanceFilterDiv').debounce('change', '.academicMaintenanceFilter > .dmsBackingData', preUpdateReadOnlyMaintenanceBrowse);
            }

            var maintainAcademicStandardsDOV = $(selector).find("#" + DOV_NAME);
            if (maintainAcademicStandardsDOV.length == 0)
            {
                return;
            }

            maintainAcademicStandardsDOV.data().selectAllWithChildrenIds = {};
            maintainAcademicStandardsDOV.data().deselectAllWithChildrenIds = {};
            maintainAcademicStandardsDOV.data().childAcademicStandardIDsToExcludeFromSelectAll = [];
            maintainAcademicStandardsDOV.data().selectedStandardIDs = [];

            var selectWithChildrenHandler =
            {
                checkChildStandardsAtLevel: function (academicStandardIDAtLevel, academicStandardIDsToExclude, skipRemoveIndividualExclude)
                {
                    var academicStandardCheckboxTableCell = maintainAcademicStandardsDOV.find("td[data-academic-standard-id='" + academicStandardIDAtLevel + "']");
                    if (academicStandardCheckboxTableCell.length > 0)
                    {
                        var fullKey = academicStandardCheckboxTableCell.data().fullKey;
                        var childStandards = selectWithChildrenHandler.findChildStandardsByParentFullKey(fullKey, academicStandardIDAtLevel);
                        selectWithChildrenHandler.applySelectAllClassToCheckboxes(childStandards.add(academicStandardCheckboxTableCell));
                        selectWithChildrenHandler.checkChildStandardsByParentFullKey(fullKey, academicStandardIDAtLevel, academicStandardIDsToExclude, skipRemoveIndividualExclude);
                    }
                },
                checkChildStandardsByParentFullKey: function (fullKey, academicStandardIDAtLevel, academicStandardIDsToExclude, skipRemoveIndividualExclude)
                {
                    selectWithChildrenHandler.selectIndividualStandard(academicStandardIDAtLevel, academicStandardIDsToExclude, skipRemoveIndividualExclude, fullKey);
                    var childStandards = selectWithChildrenHandler.findChildStandardsByParentFullKey(fullKey, academicStandardIDAtLevel);

                    $.each(childStandards, function ()
                    {
                        var childStandardTD = $(this);
                        var childAcademicStandardID = childStandardTD.data().academicStandardId;
                        selectWithChildrenHandler.selectIndividualStandard(childAcademicStandardID, academicStandardIDsToExclude, skipRemoveIndividualExclude, fullKey);
                    });
                },
                findChildStandardsByParentFullKey: function(fullKey, academicStandardIDAtLevel)
                {
                    return maintainAcademicStandardsDOV.find("td[data-full-key^='" + fullKey + "']:not([data-academic-standard-id='" + academicStandardIDAtLevel + "'])");
                },
                applySelectAllClassToCheckboxes: function(childStandards)
                {
                    $.each(childStandards, function ()
                    {
                        var childStandardTD = $(this);
                        childStandardTD.find('input[type="checkbox"]').addClass('isFromSelectAll');
                    });
                },
                selectIndividualStandard: function (academicStandardIDAtLevel, academicStandardIDsToExclude, skipRemoveIndividualExclude, fullKey)
                {
                    selectWithChildrenHandler.removeStandardFromDeselectAllList(academicStandardIDAtLevel);

                    if (!skipRemoveIndividualExclude)
                    {
                        selectWithChildrenHandler.removeIndividualExcludeStandard(academicStandardIDAtLevel);
                    }

                    if ($.inArray(academicStandardIDAtLevel, academicStandardIDsToExclude) == -1)
                    {
                        var academicStandardCheckboxAtLevel = maintainAcademicStandardsDOV.find("td[data-academic-standard-id='" + academicStandardIDAtLevel + "'] input.checkbox");
                        if (academicStandardCheckboxAtLevel.length > 0)
                        {
                            skyward.controls.setValue(academicStandardCheckboxAtLevel, true);
                            selectWithChildrenHandler.toggleChildrenIcon(academicStandardCheckboxAtLevel);
                        }

                        var selectAllWithChildrenIds = maintainAcademicStandardsDOV.data().selectAllWithChildrenIds;
                        if (fullKey && (!academicStandardIDsToExclude || $.inArray(academicStandardIDAtLevel, academicStandardIDsToExclude) == -1) &&
                            $.inArray(academicStandardIDAtLevel, selectAllWithChildrenIds) == -1)
                        {
                            selectAllWithChildrenIds[academicStandardIDAtLevel] = fullKey;
                            selectWithChildrenHandler.updateSelectAllWithChildrenIdsValue(selectAllWithChildrenIds);
                        }
                    }
                },
                uncheckChildStandardsAtLevel: function (academicStandardIDAtLevel, academicStandardIDsToExclude, skipRemoveIndividualExclude)
                {
                    var academicStandardCheckboxTableCell = maintainAcademicStandardsDOV.find("td[data-academic-standard-id='" + academicStandardIDAtLevel + "']");
                    if (academicStandardCheckboxTableCell)
                    {
                        var fullKey = academicStandardCheckboxTableCell.data().fullKey;
                        var childStandards = selectWithChildrenHandler.findChildStandardsByParentFullKey(fullKey, academicStandardIDAtLevel);
                        selectWithChildrenHandler.applySelectAllClassToCheckboxes(childStandards.add(academicStandardCheckboxTableCell));
                        selectWithChildrenHandler.uncheckChildStandardsByParentFullKey(fullKey, academicStandardIDAtLevel, academicStandardIDsToExclude, skipRemoveIndividualExclude)
                    }
                },
                uncheckChildStandardsByParentFullKey: function (fullKey, academicStandardIDAtLevel, academicStandardIDsToExclude, skipRemoveIndividualExclude)
                {
                    selectWithChildrenHandler.deselectIndividualStandard(academicStandardIDAtLevel, academicStandardIDsToExclude, skipRemoveIndividualExclude, fullKey);
                    var childStandards = selectWithChildrenHandler.findChildStandardsByParentFullKey(fullKey, academicStandardIDAtLevel);

                    $.each(childStandards, function ()
                    {
                        var childStandardTD = $(this);
                        var childAcademicStandardID = childStandardTD.data().academicStandardId;
                        selectWithChildrenHandler.deselectIndividualStandard(childAcademicStandardID, academicStandardIDsToExclude, skipRemoveIndividualExclude, fullKey);
                    });
                },
                deselectIndividualStandard: function (academicStandardIDAtLevel, academicStandardIDsToExclude, skipRemoveIndividualExclude, fullKey)
                {
                    selectWithChildrenHandler.removeStandardFromSelectAllList(academicStandardIDAtLevel);

                    if (!skipRemoveIndividualExclude)
                    {
                        selectWithChildrenHandler.removeIndividualExcludeStandard(academicStandardIDAtLevel);
                    }

                    var academicStandardCheckboxAtLevel = maintainAcademicStandardsDOV.find("td[data-academic-standard-id='" + academicStandardIDAtLevel + "'] input.checkbox");
                    if (academicStandardCheckboxAtLevel.length > 0)
                    {
                        skyward.controls.setValue(academicStandardCheckboxAtLevel, false);
                        selectWithChildrenHandler.toggleChildrenIcon(academicStandardCheckboxAtLevel);
                    }

                    var deselectAllWithChildrenIds = maintainAcademicStandardsDOV.data().deselectAllWithChildrenIds;
                    if (fullKey && (!academicStandardIDsToExclude || $.inArray(academicStandardIDAtLevel, academicStandardIDsToExclude) == -1))
                    {
                        if ($.inArray(academicStandardIDAtLevel, deselectAllWithChildrenIds) == -1)
                        {
                            deselectAllWithChildrenIds[academicStandardIDAtLevel] = fullKey;
                            selectWithChildrenHandler.updateDeSelectAllWithChildrenIdsValue(deselectAllWithChildrenIds);
                        }
                    }
                },
                defaultRequiredChildAcademicStandards: function ()
                {
                    var dovData = maintainAcademicStandardsDOV.data();
                    var selectAllList = dovData.selectAllWithChildrenIds;
                    var deselectAllList = dovData.deselectAllWithChildrenIds;

                    var dirtyInputsToSkipSelectAllLogic = dovData.childAcademicStandardIDsToExcludeFromSelectAll;

                    if (selectAllList)
                    {
                        for (var standardID in selectAllList)
                        {
                            var fullKey = selectAllList[standardID];
                            selectWithChildrenHandler.checkChildStandardsByParentFullKey(fullKey, standardID, dirtyInputsToSkipSelectAllLogic, true);
                        }
                    }

                    if (deselectAllList)
                    {
                        for (var standardID in deselectAllList)
                        {
                            var fullKey = deselectAllList[standardID];
                            selectWithChildrenHandler.uncheckChildStandardsByParentFullKey(fullKey, standardID, dirtyInputsToSkipSelectAllLogic, true);
                        }
                    }
                },
                defaultSelectedStandards: function ()
                {
                    var dovData = maintainAcademicStandardsDOV.data();
                    selectedStandardIDs = dovData.selectedStandardIDs;
                    if (selectedStandardIDs && selectedStandardIDs.length > 0)
                    {
                        for (var i = 0; i < selectedStandardIDs.length; i++)
                        {
                            selectWithChildrenHandler.selectIndividualStandard(selectedStandardIDs[i], dovData.childAcademicStandardIDsToExcludeFromSelectAll, true);
                        }
                    }
                },
                //returns whether or not it was successful
                toggleChildrenIcon: function (academicStandardCheckboxAtLevel)
                {
                    var cell = academicStandardCheckboxAtLevel.parents("td");

                    var selectChildrenCell = maintainAcademicStandardsDOV.find("td[data-select-all-with-children-academic-standard-id='" + cell.data().academicStandardId + "']");

                    var isCurrentlyChecked = academicStandardCheckboxAtLevel.is(":checked");
                    if (!selectChildrenCell.hasClass("deselect") && isCurrentlyChecked)
                    {
                        if (!selectChildrenCell.find(".svg.deselectAcademicStandardWithChildren").length && selectChildrenCell.find(".svg.selectAcademicStandardWithChildren").length > 0)
                        {
                            //Only copy icon if there is a select icon, if there isn't a select icon then its the lowest level and there shouldn't be an icon
                            selectWithChildrenHandler.copyDeselectIconToCell(selectChildrenCell);
                        }

                        selectChildrenCell.find(".svg.selectAcademicStandardWithChildren").hide();
                        selectChildrenCell.find(".svg.deselectAcademicStandardWithChildren").show();
                        selectChildrenCell.addClass("deselect");
                    }
                    else if (!isCurrentlyChecked)
                    {
                        selectChildrenCell.find(".svg.selectAcademicStandardWithChildren").show();
                        selectChildrenCell.find(".svg.deselectAcademicStandardWithChildren").hide();
                        selectChildrenCell.removeClass("deselect");
                    }
                    else
                    {
                        return false;
                    }

                    return true;
                },
                updateChildAcademicStandardIDsToExcludeFromSelectAllValue: function (childAcademicStandardIDsToExcludeFromSelectAll)
                {
                    $("#MaintainAcademicStandardsDOV_ChildAcademicStandardIDsToExcludeFromSelectAll").val(JSON.stringify(childAcademicStandardIDsToExcludeFromSelectAll));
                },
                updateSelectAllWithChildrenIdsValue: function (selectAllWithChildrenIds)
                {
                    $("#MaintainAcademicStandardsDOV_SelectAllWithChildrenIds").val(JSON.stringify(selectAllWithChildrenIds));
                },
                updateDeSelectAllWithChildrenIdsValue: function (deselectAllWithChildrenIds)
                {
                    $("#MaintainAcademicStandardsDOV_DeSelectAllWithChildrenIds").val(JSON.stringify(deselectAllWithChildrenIds));
                },
                updateAllSelectedIdsValue: function (deselectAllWithChildrenIds)
                {
                    $("#MaintainAcademicStandardsDOV_AllSelectedIds").val(JSON.stringify(deselectAllWithChildrenIds));
                },
                removeIndividualExcludeStandard: function (academicStandardID)
                {
                    var childAcademicStandardIDsToExcludeFromSelectAll = maintainAcademicStandardsDOV.data().childAcademicStandardIDsToExcludeFromSelectAll;

                    var index = childAcademicStandardIDsToExcludeFromSelectAll.indexOf(academicStandardID);

                    if (index > -1)
                    {
                        childAcademicStandardIDsToExcludeFromSelectAll.splice(index, 1);
                    }

                    selectWithChildrenHandler.updateChildAcademicStandardIDsToExcludeFromSelectAllValue(childAcademicStandardIDsToExcludeFromSelectAll);
                },
                addIndividualExcludeStandard: function (academicStandardID)
                {
                    var childAcademicStandardIDsToExcludeFromSelectAll = maintainAcademicStandardsDOV.data().childAcademicStandardIDsToExcludeFromSelectAll;

                    var index = childAcademicStandardIDsToExcludeFromSelectAll.indexOf(academicStandardID);

                    if (!(index > -1))
                    {
                        childAcademicStandardIDsToExcludeFromSelectAll.push(academicStandardID);
                        selectWithChildrenHandler.updateChildAcademicStandardIDsToExcludeFromSelectAllValue(childAcademicStandardIDsToExcludeFromSelectAll)
                    }
                },
                removeStandardFromDeselectAllList: function (academicStandardID)
                {
                    var deselectAllWithChildrenIds = maintainAcademicStandardsDOV.data().deselectAllWithChildrenIds;

                    delete deselectAllWithChildrenIds[academicStandardID];

                    selectWithChildrenHandler.updateDeSelectAllWithChildrenIdsValue(deselectAllWithChildrenIds);
                },
                removeStandardFromSelectAllList: function (academicStandardID)
                {
                    var selectAllWithChildrenIds = maintainAcademicStandardsDOV.data().selectAllWithChildrenIds;

                    delete selectAllWithChildrenIds[academicStandardID];

                    selectWithChildrenHandler.updateSelectAllWithChildrenIdsValue(selectAllWithChildrenIds);
                },
                removeStandardFromSelectedIDsList: function (academicStandardID)
                {
                    var selectedIDs = maintainAcademicStandardsDOV.data().selectedStandardIDs;

                    var index = selectedIDs.indexOf(academicStandardID);

                    if (index > -1)
                    {
                        selectedIDs.splice(index, 1);
                    }

                    selectWithChildrenHandler.removeStandardFromSelectAllList(academicStandardID);
                    selectWithChildrenHandler.updateAllSelectedIdsValue(selectedIDs);
                },
                addStandardToSelectedIDsList: function (academicStandardID)
                {
                    var selectedIDs = maintainAcademicStandardsDOV.data().selectedStandardIDs;

                    var index = selectedIDs.indexOf(academicStandardID);

                    if (!(index > -1))
                    {
                        selectedIDs.push(academicStandardID);
                        selectWithChildrenHandler.updateAllSelectedIdsValue(selectedIDs)
                    }
                },
                copyDeselectIconToCell: function (td)
                {
                    var deselectIcon = skyward.svg.getSvg("Reselect");
                    deselectIcon.addClass("deselectAcademicStandardWithChildren svg");
                    deselectIcon.removeClass("svgHidden");
                    deselectIcon.appendTo(td.find("div"));
                },
                setup: function()
                {
                    $("body").off("browseLoaded." + BROWSE_NAME).on("browseLoaded." + BROWSE_NAME, function ()
                    {
                        selectWithChildrenHandler.defaultRequiredChildAcademicStandards();
                        selectWithChildrenHandler.defaultSelectedStandards();
                    });

                    maintainAcademicStandardsDOV.on("click", "td[data-select-all-with-children='true']:not(.deselect)", function ()
                    {
                        var td = $(this);

                        if (td.find("svg:not(.svgHidden)").length < 1)
                        {
                            return;
                        }
                        var tdData = td.data();
                        var academicStandardID = tdData.selectAllWithChildrenAcademicStandardId;

                        selectWithChildrenHandler.checkChildStandardsAtLevel(academicStandardID, tdData.childAcademicStandardIDsToExcludeFromSelectAll);
                    });

                    maintainAcademicStandardsDOV.on("click", "td[data-select-all-with-children='true'].deselect", function ()
                    {
                        var td = $(this);

                        if (td.find("svg:not(.svgHidden)").length < 1)
                        {
                            return;
                        }
                        var tdData = td.data();
                        var academicStandardID = tdData.selectAllWithChildrenAcademicStandardId;

                        selectWithChildrenHandler.uncheckChildStandardsAtLevel(academicStandardID, tdData.childAcademicStandardIDsToExcludeFromSelectAll);
                    });

                    maintainAcademicStandardsDOV.on("change", ".selectAcademicStandard", function (event)
                    {
                        var checkbox = $(this);
                        var td = checkbox.parents("td").first();
                        var standardID = td.data().academicStandardId;
                        if (standardID && checkbox[0].checked)
                        {
                            selectWithChildrenHandler.addStandardToSelectedIDsList(standardID);
                        }
                        else
                        {
                            selectWithChildrenHandler.removeStandardFromSelectedIDsList(standardID);
                        }

                        if (checkbox.hasClass('isFromSelectAll'))
                        {
                            //this means it was triggered from the mass select with children. 
                            //we only want to keep track of individual ones
                            checkbox.removeClass('isFromSelectAll');
                            event.stopPropagation();
                            event.preventDefault();
                            return;
                        }
                        if (standardID && !checkbox[0].checked)
                        {
                            selectWithChildrenHandler.addIndividualExcludeStandard(standardID);
                        }
                        else
                        {
                            selectWithChildrenHandler.removeIndividualExcludeStandard(standardID);
                        }
                    });
                }
            };

            selectWithChildrenHandler.setup();

            var changeAcademicStandardFilters = function ()
            {
                var browseName = $(this).parents('#' + DOV_NAME).find('.editablebrowse').attr('id');
                if (browseName.length == null)
                {
                    return;
                }
                clearAcademicStandardFilters();
                reloadLevelSpecificAcademicStandardFilters();
            };

            var clearAcademicStandardFilters = function ()
            {
                $('.academicMaintenanceFilter:not(#AcademicStandardSetFilter)').each(function ()
                {
                    var filter = $(this);
                    filter.trigger('clearAll');
                });
            };

            var reloadLevelSpecificAcademicStandardFilters = function () {
                $.ajax({
                    url: skyward.global.virtualDir + ((skyward.browse.browseList[BROWSE_NAME].data.CalculationGroupID !== undefined) ? GRADEBOOK_PATH : CURRICULUM_PATH) + "/GetAcademicStandardFiltersForEachLevel",
                    type: "POST",
                    dataType: "viewparthtml",
                    activityIndicator: { silent: true },
                    data: 
                    {
                        academicSetID: $('#AcademicStandardSetFilter').val()
                    },
                    success: function (html)
                    {
                        $(".academicStandardFilterAtLevelFieldset").each(function ()
                        {
                            var filterAtLevel = $(this);
                            filterAtLevel.remove();
                        });

                        $(".academicStandardMaintenanceFilterDiv").append(html);
                        skyward.window.notifyDOMLoad(".academicStandardMaintenanceFilterDiv");
                    }
                });
            };
            
            var preUpdateAcademicStandardMaintenanceBrowse = function ()
            {
                if (updateMaintenanceBrowseAjaxRequest)
                {
                    updateMaintenanceBrowseAjaxRequest.abort();
                }
                
                updateAcademicStandardMaintenanceBrowse();
                
            };

            var updateAcademicStandardMaintenanceBrowse = function ()
            {
                var browseElement = skyward.browse.browseList[BROWSE_NAME] !== undefined ? skyward.browse.browseList[BROWSE_NAME] : skyward.browse.browseList["detailsPanel_" + BROWSE_NAME];
                var browseData = $("#" + BROWSE_NAME).data();
                var includeExistingRecords = true;
                if (browseData && browseData.includeExistingRecords != null)
                {
                    includeExistingRecords = browseData.includeExistingRecords;
                }
                var data = {
                    pageModule: browseElement.pageModule,
                    pageObject: browseElement.pageObject,
                    pageScreen: browseElement.pageScreen,
                    taskName: browseElement.taskName,
                    curriculumID: browseElement.data.CurriculumID,
                    calculationGroupID: browseElement.data.CalculationGroupID,
                    academicSetIDs: $('#AcademicStandardSetFilter').val(),
                    academicSubjectIDs: $('#AcademicStandardSubjectFilterData').val(),
                    academicGradeRangeIDs: $('#AcademicStandardGradeRangeFilterData').val(),
                    includeExistingRecords: includeExistingRecords,
                    renderInDetailsPanel: isInDetailsPanel
                };

                var url = skyward.global.virtualDir + ((browseElement.data.CalculationGroupID !== undefined) ? GRADEBOOK_PATH : CURRICULUM_PATH) + "/UpdateAcademicStandardMaintenanceBrowse";
                var browseParentSelector = (browseElement.data.CalculationGroupID !== undefined) ? '#' + BROWSE_NAME + 'Div' : '#' + BROWSE_NAME + 'Div';
                var browseSelector = '.editablebrowse';

                return sharedUpdateAcademicStandardMaintenanceBrowse(data, url, browseParentSelector, browseSelector, BROWSE_NAME);
            }

            $(selector).find('#AcademicStandardSetFilter').on('change', changeAcademicStandardFilters);
            $(selector).find('.academicStandardMaintenanceFilterDiv').debounce('change', '.academicMaintenanceFilter > .dmsBackingData', preUpdateAcademicStandardMaintenanceBrowse);
        };

        //Bootstrap
        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);